// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/es7.set.of.js
 ** module id = 2463
 ** module chunks = 3
 **/